
import '../index.css'
import React, {useRef} from "react";
import  {ResetPasswordDialog}  from "./components/resetPasswordDialog";
import AuthService from "@/services/auth";
import {useNavigate} from "react-router-dom";
import Header from "@/components/header";

export default function resetPassword() {
    const navigator = useNavigate()
    const userInfo = AuthService.getUserInfo()

    // 创建弹窗引用
    //const resetPasswordDialogRef = useRef<{ open: () => void }>(null);
    // 新增成功后的回调
    const handleAddSuccess = (res:any) => {
        console.log(res);
        console.log("重置密码成功");

    };

    return (
        <div className="bg-background flex-1 flex flex-col" style={{"borderRadius": 16}}>
            <Header/>
            <div className="flex flex-1">
                {/* 激活弹窗*/}
                <ResetPasswordDialog
                    onSuccess={handleAddSuccess}
                />

            </div>

        </div>
    );
}

